import {Component, Inject} from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-confirm-delete-comment',
   templateUrl: 'delete-comment.component.html',
   styleUrls: ['delete-comment.component.css']
})
export class DeleteCommentComponent {
   progress: boolean;

   constructor(private dialogRef: MatDialogRef<DeleteCommentComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   /**
    *
    * @detail :  Check that all buttons are pressed
    */

   justDelete(deleteButton: MatButton, cancelButton: MatButton) {
      deleteButton.disabled = true;
      cancelButton.disabled = true;
      this.progress = true;
      this.data.service.deleteComment(this.data.item.id)
         .subscribe(
            () => {
               this.dialogRef.close(true);
            },
            error => {
               this.dialogRef.close();
            });
   }
}
